import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Input, Textarea } from '@components/common'
import CertificateSelector from '@components/common/CertificateSelector'
import { useProjectWizardStore } from '@store/useProjectWizardStore'
import '../ProjectWizard.scss'

/**
 * Step 1: Basic Details
 *
 * Collects project name, description, and compliance standards
 */
const BasicDetailsStep = ({ onValidChange }) => {
	const {
		basicDetails,
		setProjectName,
		setProjectDescription,
		setCertificates,
	} = useProjectWizardStore()

	const [errors, setErrors] = useState({})

	// Validate form
	useEffect(() => {
		const newErrors = {}

		if (!basicDetails.name.trim()) {
			newErrors.name = 'Project name is required'
		} else if (basicDetails.name.trim().length < 3) {
			newErrors.name = 'Project name must be at least 3 characters'
		}

		if (basicDetails.certificates.length === 0) {
			newErrors.certificates = 'At least one compliance standard is required'
		}

		setErrors(newErrors)

		const isValid = Object.keys(newErrors).length === 0
		onValidChange && onValidChange(isValid)
	}, [basicDetails, onValidChange])

	return (
		<div className="wizard-step">
			<div className="wizard-step__header">
				<h2 className="wizard-step__title">Basic Details</h2>
				<p className="wizard-step__description">
					Enter the basic information about your compliance project
				</p>
			</div>

			<div className="wizard-step__content">
				<div className="form-grid">
					{/* Project Name */}
					<div className="form-group form-group--full">
						<Input
							label="Project Name"
							placeholder="Enter project name"
							value={basicDetails.name}
							onChange={(e) => setProjectName(e.target.value)}
							error={errors.name}
							required
						/>
					</div>

					{/* Project Description */}
					<div className="form-group form-group--full">
						<Textarea
							label="Project Description"
							placeholder="Describe the scope and objectives of this compliance project..."
							value={basicDetails.description}
							onChange={(e) => setProjectDescription(e.target.value)}
							rows={4}
						/>
					</div>

					{/* Compliance Standards */}
					<div className="form-group form-group--full">
						<label className="form-label">
							Compliance Standards / Certifications <span className="required">*</span>
						</label>
						<p className="form-helper-text">
							Select the compliance standards that this project will address
						</p>
						<CertificateSelector
							value={basicDetails.certificates}
							onChange={setCertificates}
							error={errors.certificates}
						/>
						{errors.certificates && (
							<span className="form-error">{errors.certificates}</span>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

BasicDetailsStep.propTypes = {
	onValidChange: PropTypes.func,
}

export default BasicDetailsStep
